export default function PaymentOptions({handle1, handle2}){
    return(
        <>
            <h5 className="fw-bold text-dark mt-3">Betalning</h5>
            <button
                className="btn w-100 fw-semibold d-flex align-items-center justify-content-center mb-2"
                style={{
                    height: "50px",
                    border: "2px solid #45B128",
                }}
                onClick={handle1}
            >
                <img
                    src="https://hjarnkraft.se/wp-content/uploads/2023/04/Swish-Logo-Secondary-Light-BG.png"
                    alt="Swish"
                    style={{ height: "90%", objectFit: "contain" }}
                />
            </button>
            { 
            <button
                className="btn btn-warning w-100 fw-bold d-flex gap-2 text-muted align-items-center justify-content-center"
                style={{height: "50px"}}
                onClick={handle2}
            >
                <span className="fs-5 m-0">Kort</span> <i className="bi bi-credit-card fs-4 m-0"></i>
                
            </button>
            }
        </>
    )
}